(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["infographic-mobile"] && !window.DesignMode) return;
  try {
    
$(function(){
  $(window).resize(function(){
    var width  = $(window).width()-16,
        height = $(window).height();
    
      $('.container-info-mobile .features_block').css('width', width);
      $('.container-info-mobile .features_block').css('height', width/0.8);
    
  }).trigger('resize');
});
$(function() {
  $('.features_block>a').click(function() {

    //Check if the tabs menu has active class
    $('.features_block svg').removeClass('active');
    $(this).addClass('active');

    // Display active tab
    var currentTab = $(this).attr('href');
    $('.top_feature').hide();
    $(currentTab).show();

    return false;
  });
});

  } catch(e) { console.error(e); }
})();

})();
